module.exports = __webpack_public_path__ + "static/img/solutions6.11f132b2.png";